import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { SafeUrl } from "@angular/platform-browser";

@Injectable({ providedIn: "root" })
export class ImagePreviewService {
    private _url = new BehaviorSubject<SafeUrl | null>(null);
    readonly url$ = this._url.asObservable();

    show(url: SafeUrl): void {
        this._url.next(url);
    }

    hide(): void {
        this._url.next(null);
    }
}
